<template>
    <div>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="childMsg.currentPage"
            :page-sizes="[5, 10, 20, 30, 40, 50]"
            :page-size="childMsg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="childMsg.total">
        </el-pagination>
    </div>
</template>
<script>
export default {
    name: 'Pagination',
    props: ['childMsg'],
    data() {
        return {
            pageParams: {
                currentPage: this.childMsg.currentPage,
                pageSize: this.childMsg.pageSize
            }
        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageParams.pageSize = val
            this.pageParams.currentPage = 1
            this.$emit('pageChange', this.pageParams)
        },
        handleCurrentChange(val) {
            this.pageParams.currentPage = val
            this.$emit('pageChange', this.pageParams)
            this.$nextTick(() => {
                let scrollContainer = document.getElementById('scrollContainer')
                scrollContainer.scrollTop = 0
            })
        }
    }
}
</script>
